import React from 'react';
import { Tab } from 'semantic-ui-react';
import { SignUp } from '../Forms';

const SignUpTabPane = (props) => {
  return (
    <Tab.Pane>
      <SignUp
        onSubmit={props.onSubmit}
        error={props.error}
        success={props.success}
      />
    </Tab.Pane>
  );
};

export default SignUpTabPane;



// WEBPACK FOOTER //
// ./src/public/components/Auth/TabPanes/SignUpTabPane.js